export type EventData = {
  google_event_date?: string;
  all_day?: boolean;
  event_date?: string | number;
};

function parseStoredEventTimestamp(value: string): Date | null {
  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }

  const raw = Number(trimmed);
  if (!Number.isFinite(raw)) {
    return null;
  }

  const ms = raw < 1e12 ? raw * 1000 : raw;
  const date = new Date(ms);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function getEventDate(event: EventData): Date {
  const { google_event_date, all_day, event_date } = event;

  if (google_event_date) {
    if (all_day) {
      // For all-day events, google_event_date is a date-only ISO string
      const [year, month, day] = google_event_date.split('-').map(Number);
      if (year && month && day) {
        return new Date(year, month - 1, day);
      }
    }

    const fromStoredTimestamp = parseStoredEventTimestamp(google_event_date);
    if (fromStoredTimestamp) {
      return fromStoredTimestamp;
    }

    const parsed = new Date(google_event_date);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  return new Date(Number(event_date));
}
